import { Card } from "react-bootstrap";
import { FaEye } from "react-icons/fa";

import ColorSchema from "../../kits/Color";
import { TrashIcon } from "../../kits/Icons";
import { pathMaker, swalFunc } from "../../../utils/helperFunction";

import placeholder from "../../../assets/images/placeholder-image.png";
export default function AttributeItem({ data, deactivatePropertyFunc }) {
  return (
    <Card
      className="p-1 d-flex flex-row attribute-item"
      style={{ borderColor: ColorSchema.blue_custom }}
    >
      <img
        className="me-2 my-auto"
        style={{ width: 80, height: 60 }}
        src={
          data?.file_path != "" &&
          data?.file_path != undefined &&
          data?.file_path != null
            ? pathMaker(data?.file_path)
            : placeholder
        }
      />
      <div
        className="flex-grow-1 d-flex flex-column justify-content-evenly"
        style={{ lineHeight: 1.5 }}
      >
        <div className="d-flex flex-wrap">
          <div className="title d-flex">
            <label className="d-flex align-items-center">
              <FaEye
                className="me-1"
                style={{ width: 20, height: 20 }}
                color={
                  data?.seen_by_user == 1
                    ? ColorSchema.success_custom
                    : ColorSchema.danger_custom
                }
              />
              عنوان صفت :
            </label>
            <span className="value ms-1">
              {data?.title != "" ? data?.title : "---"}
            </span>
          </div>
          <div className="ms-auto me-3 val-container">
            <label>نوع صفت :</label>
            <span className="value ms-1">
              {data?.type == "2" ? "انتخابی" : "ورودی"}
            </span>
          </div>
        </div>
        {data?.type == "2" && (
          <div>
            <div className="ms-auto me-3">
              <label>گزینه ها :</label>
              <span className="value ms-1">
                {data?.optionsList?.map((v, i) => {
                  return `${v} ${i < data?.optionsList?.length - 1 ? "," : ""}`;
                })}
              </span>
            </div>
          </div>
        )}
        {data?.type == "1" && (
          <div>
            <div className="ms-auto me-3">
              <span>
                <label>حداقل ورودی :</label>
                <span className="value ms-1">{data?.min_input}</span>
              </span>
              &nbsp; &nbsp;&nbsp; &nbsp;
              <span>
                <label>حداکثر ورودی :</label>
                <span className="value ms-1">{data?.max_input}</span>
              </span>
            </div>
          </div>
        )}
      </div>
      <div
        className="d-flex align-self-end"
        onClick={() =>
          swalFunc(
            `آیا از حذف این صفت مطمئن هستید؟`,
            () => deactivatePropertyFunc(data.product_properties__id),
            "warning"
          )
        }
      >
        <TrashIcon
          color={ColorSchema.red_custom}
          style={{ width: 20, height: 20, cursor: "pointer" }}
        />
      </div>
    </Card>
  );
}
